import React from 'react';
import TranslationNamespaces from '../../../locales/TranslationNamespaces';
import { useTranslation } from 'react-i18next';
import { Chip, Box } from '@mui/material';
import { AccountCircleSharp, Public } from '@mui/icons-material';
import { QSpinner } from '@kubiq-base/core';

interface Props {
  text?: string;
  emailBox?: boolean;
  linkBox?: boolean;
  isLoading?: boolean;
  icon?: JSX.Element;
}

const MessageBox = ({ text, emailBox, linkBox, isLoading, icon }: Props): JSX.Element => {
  const { t } = useTranslation(TranslationNamespaces.global);
  return (
    <Box sx={{ display: 'flex', justifyContent: 'center', pt: 2, px: 5 }}>
      <Chip
        avatar={
          icon ? (
            icon
          ) : isLoading ? (
            <Box sx={{ pr: '24px', ml: -1, overflow: 'hidden' }}>
              <QSpinner size={24} />
            </Box>
          ) : emailBox ? (
            <AccountCircleSharp />
          ) : linkBox ? (
            <Public />
          ) : undefined
        }
        label={isLoading ? t('loading') : text}
      />
    </Box>
  );
};

export default MessageBox;
